import Localization from "../../localization";
import { Text } from "../../components";
import React from "react";

const Webhook = () => {
  return (
    <>
      <Text
        className="m-15-t m-10-b"
        type="secondary"
        weight={400}
        children={Localization.configure_device.http_description}
      />
      {React.Children.toArray(
        [
          Localization.configure_device.http_description_ex_0,
          Localization.configure_device.http_description_ex_1,
        ].map((text) => (
          <Text
            weight={600}
            type="secondary"
            children={<>•&nbsp;&nbsp;{text}</>}
          />
        ))
      )}
    </>
  );
};

export default Webhook;
